import styled, { css } from 'styled-components';
import { VideoPlayer as VideoPlayerComponent } from 'src/components';
import _PlayButton from './PlayButton';

export type LearnableProps = {
  $palette: 'blue' | 'red';
};

export const Data = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};
    margin-left: ${theme.sz.s4};
    margin-right: ${theme.sz.s4};
  `,
);

export const Label = styled.div(
  ({ theme }) => css`
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.DEPRECATED_ty.small};
    line-height: ${theme.DEPRECATED_ty.mediumLarge};
  `,
);

export const LearnableCard = styled.div<LearnableProps>(
  ({ theme, $palette }) => css`
    width: 193px;
    border-style: solid;
    border-radius: ${theme.sz.s4};
    border-width: 3px;
    color: ${theme.co.primary99};
    font-family: ${theme.DEPRECATED_ty.openSans};
    overflow: hidden;

    ${
      $palette === 'blue' &&
      css`
        background-color: ${theme.co.secondary0};
        border-color: ${theme.co.secondary20};

        > ${VideoPlayer} > video {
          border-color: ${theme.co.secondary20};
        }
      `
    }

    ${
      $palette === 'red' &&
      css`
        background-color: #260202; // No alternatives in theme, universal red
        border-color: ${theme.co.error20};

        > ${VideoPlayer} > video {
          border-color: ${theme.co.error20};
        }
      `
    }
  `,
);

export const Meta = styled.div(
  ({ theme }) => css`
    font-size: ${theme.DEPRECATED_ty.smaller};
    line-height: ${theme.DEPRECATED_ty.mediumLarge};
  `,
);

export const PlayButton = styled(_PlayButton)(
  ({ theme }) => css`
    margin-top: ${theme.sz.s4};
    margin-left: ${theme.sz.s4};
    margin-right: ${theme.sz.s4};
  `,
);

export const Target = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s2};
    font-size: ${theme.DEPRECATED_ty.small};
    line-height: ${theme.DEPRECATED_ty.mediumLarge};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
);

export const VideoPlayer = styled(VideoPlayerComponent)(
  ({ theme }) => css`
    margin-bottom: ${theme.sz.s4};

    > video {
      width: 187px;
      height: 158px;
      object-fit: cover;
      display: block;
      // ! Fixes crop for safari
      margin-top: -3px;
      margin-left: -3px;
      background-color: ${theme.co.neutral0};
      border-radius: ${theme.bo.medium} ${theme.bo.medium} 0 0;
      border-width: 3px 3px 0 3px;
      border-style: solid;
    }
  `,
);
